import Platform from '../platform';
import {setInfoMessage} from '../managers/client-log.manager';

let _deferredPrompt = null;
let _isInstalled = false;

export const initPWAInstall = (onPWAInstallAvailable, onPWAInstalled) => {
	setInfoMessage('Init PWA install');

	global.addEventListener('beforeinstallprompt', e => {
		if (!e) {
			return;
		}

		e.preventDefault();
		_deferredPrompt = e;
		onPWAInstallAvailable();
	});

	console.log('+-+ subscribe for appinstalled event');
	global.addEventListener('appinstalled', e => {
		_isInstalled = true;
		onPWAInstalled();
		console.log('+-+ appinstalled event');
	});

};

export const registerPWAServiceWorker = () => {
	if ('serviceWorker' in navigator) {
		try {
			navigator.serviceWorker.register('/pwa-service-worker.js');
			setInfoMessage('ServiceWorker registered');
		} catch (e) {
			setInfoMessage('ServiceWorker registration failed');
			console.log('ServiceWorker registration failed. Sorry about that.');
		}
	} else {
		setInfoMessage('ServiceWorker not available');
		document.querySelector('.alert')?.removeAttribute('hidden');
	}
};

export const isPWAInstallAvailable = () => {
	if (Platform.isPWA || Platform.isNativeApp) {
		return false;
	}

	return Platform.isIOs ||
		(Platform.isAndroid && !!_deferredPrompt && !_isInstalled);
};

export const triggerPWAInstall = () => {
	_deferredPrompt.prompt();

	_deferredPrompt.userChoice.then(choiceResult => {
		if (choiceResult.outcome === 'accepted') {
			console.log('User accepted the A2HS prompt');
		} else {
			console.log('User dismissed the A2HS prompt');
		}
		_deferredPrompt = null;
	});
};
